export default __webpack_public_path__ + "static/media/class5Qp.b1bd5fee.png";